import { $apiDelete, $apiGet, $apiPost, $apiPut } from '~/utils/request'
import type { Agency } from '~/models'

export const GetCourtByNameKeyword = (query: { nameKeyword: string }, isLoading?) => $apiGet<Agency[]>(`/v1/agency/courtByNameKeyword`, query, isLoading)
